import { resolveComponent as d, resolveDirective as u, openBlock as i, createBlock as n, withCtx as r, renderSlot as b, withDirectives as w, mergeProps as g, withKeys as s, withModifiers as l, resolveDynamicComponent as v } from "vue";
import { _ } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
import y from "../dropdown/dropdown.js";
import h from "../button/button.js";
const D = {
  name: "EditorToolbardropdownButton",
  components: {
    DtButton: h,
    DtDropdown: y
  },
  props: {
    /**
     * Whether the button is active
     */
    isActive: {
      type: Boolean,
      default: !1
    },
    /**
     * Tooltip message
     */
    tooltipMessage: {
      type: String,
      required: !0
    },
    /**
     * Data QA attribute for testing
     */
    dataQa: {
      type: String,
      default: ""
    },
    /**
     * dropdown specific data QA attribute
     */
    dropdownDataQa: {
      type: String,
      default: ""
    },
    /**
     * Tab index for keyboard navigation
     */
    tabindex: {
      type: Number,
      default: -1
    },
    /**
     * Icon component
     */
    icon: {
      type: Object,
      required: !0
    }
  },
  emits: [
    /**
     * Emitted when right arrow key is pressed
     */
    "shift-focus-right",
    /**
     * Emitted when left arrow key is pressed
     */
    "shift-focus-left"
  ]
};
function q(o, e, t, x, B, Q) {
  const p = d("dt-button"), c = d("dt-dropdown"), f = u("dt-tooltip");
  return i(), n(c, {
    "data-qa": t.dropdownDataQa || `${t.dataQa}-dropdown`,
    padding: "small",
    "navigation-type": "arrow-keys",
    placement: "bottom-start"
  }, {
    anchor: r(({ attrs: a }) => [
      w((i(), n(p, g({ ref: "buttonRef" }, a, {
        active: t.isActive,
        "aria-label": t.tooltipMessage,
        "data-qa": t.dataQa,
        tabindex: t.tabindex,
        importance: "clear",
        kind: "muted",
        size: "xs",
        onKeydown: [
          e[0] || (e[0] = s(l((m) => o.$emit("shift-focus-right"), ["stop"]), ["right"])),
          e[1] || (e[1] = s(l((m) => o.$emit("shift-focus-left"), ["stop"]), ["left"]))
        ]
      }), {
        icon: r(() => [
          (i(), n(v(t.icon), { size: "200" }))
        ]),
        _: 1
      }, 16, ["active", "aria-label", "data-qa", "tabindex"])), [
        [f, { message: t.tooltipMessage, placement: "top" }]
      ])
    ]),
    list: r(({ close: a }) => [
      b(o.$slots, "list", { close: a })
    ]),
    _: 3
  }, 8, ["data-qa"]);
}
const z = /* @__PURE__ */ _(D, [["render", q]]);
export {
  z as default
};
//# sourceMappingURL=EditorToolbarDropdownButton.js.map
